import React, { useEffect, useState } from "react";
import {
  Docdownload,
  Eyelight,
  Upwardarrow,
  ViewsIcons,
} from "../../../../../utility/constants/assetsManager";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import CustomModal from "../../../../components/main_comps/custom_modal";
import CustomUploadField from "../../../../components/ui_comps/CustomUploadField";
import CustomUploadField2 from "../../../../components/ui_comps/CustomUploadField2";
import custom_getvalue from "../../../../components/main_comps/custom_getvalue";

const DocumentComponent = ({
  label,
  value,
  isEditClicked,
  onChange,
  imageTypeArray = ["pdf"],
  accept = ".pdf",
}) => {
  const getNameFromUrl = (url) => {
    if (url) {
      return decodeURIComponent(url.split("/").pop());
    }
  };

  return (
    <div style={{ marginTop: 20 }}>
      <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
        {label}
      </label>
      {isEditClicked ? (
        <CustomUploadField2
          document={label}
          customIcon={<Upwardarrow />}
          value={value}
          onChange={(data) => {
            onChange(data);
          }}
          onClickRemove={() => {
            onChange("");
          }}
          filesize={60}
          style={{
            width: "350px",
            height: "40px",
            border: "1px solid #CBCACA",
            background: "white",
            maxWidth: "350px",
            padding: "0px 10px",
            marginBottom: "0px",
          }}
          containerStyle={{
            height: "40px",
            padding: "0px",
          }}
          textStyles={{
            fontSize: 13,
            color: "#697D95",
          }}
          imageTypeArray={imageTypeArray}
          accept={accept}
        />
      ) : (
        <div
          style={{
            width: "350px",
            height: "40px",
            border: "1px solid #CBCACA",
            borderRadius: 5,
            fontSize: 13,
            color: "#697D95",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0px 10px",
          }}
        >
          <div>
            {getNameFromUrl(value)?.length > 15
              ? getNameFromUrl(value)?.slice(0, 15) + "..."
              : getNameFromUrl(value)}
          </div>
          <div
            style={{
              width: 80,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <a
              href={value}
              download
              color="transparent"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Docdownload />
            </a>
            <a
              href={value}
              color="transparent"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ViewsIcons />
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

const RadioButton = ({
  id,
  value,
  name,
  title,
  onChange,
  defaultChecked,
  style,
  disabled,
}) => {
  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <input
        disabled={disabled}
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={defaultChecked}
        style={{
          margin: "0px 10px",
        }}
      />
      <label htmlFor={id}>{title}</label>
    </div>
  );
};

function Vkyc({ clientData, isEditClicked, onChange }) {
  const [isKycVerified, setIsKycVerified] = useState();
  const [currentValue, setCurrentValue] = useState("");
  const [rolling, setRolling] = useState("");
  const [rollingStatus, setRollingStatus] = useState("");
  const [securityDepositStatus, setSecurityDepositStatus] = useState("");
  const [securityDeposit, setSecurityDeposit] = useState("");
  const [video, setVideo] = useState("");
  const [file, setFile] = useState({});
  const [state, setState] = useState("");
  const [modal, setModal] = useState(false);

  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",
    color: "#000000",
  };
  const containerStyle = {
    width: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 20px 0",
    paddingLeft: "10px",
  };

  useEffect(() => {
    if (!isEditClicked) {
      setIsKycVerified(clientData?.isKycVerified);
      setVideo(clientData?.videoKycUrl);
      setRollingStatus(clientData?.rollbackReserves?.status);
      setSecurityDepositStatus(clientData?.security?.status);
      setRolling(clientData?.rollbackReserves?.percentage);
      setSecurityDeposit(clientData?.security?.amount / 100);
    } else setVideo("");
  }, [isEditClicked]);

  useEffect(() => {
    if (clientData?.rollbackReserves || clientData?.security) {
      if (clientData?.isKycVerified) {
        if (clientData?.rollbackReserves?.status) {
          setRolling(clientData?.rollbackReserves?.percentage);
          setCurrentValue("rolling");
        } else {
          setSecurityDeposit(clientData?.security?.amount / 100);
          setCurrentValue("security");
        }
      } else {
        setRolling(clientData?.rollbackReserves?.percentage);
        setSecurityDeposit(clientData?.security?.amount / 100);
      }
      setIsKycVerified(clientData?.isKycVerified);
    }
  }, []);

  useEffect(() => {
    if (isEditClicked) {
      let rollbackReserves = {};
      let security = {};
      if (rolling) {
        rollbackReserves = { ...rollbackReserves, percentage: rolling };
      } else {
        rollbackReserves = {
          ...rollbackReserves,
          percentage: clientData?.rollbackReserves?.percentage,
        };
      }

      if (rollingStatus.toString()) {
        rollbackReserves = { ...rollbackReserves, status: rollingStatus };
      } else {
        rollbackReserves = {
          ...rollbackReserves,
          status: clientData?.rollbackReserves?.status,
        };
      }

      if (securityDeposit) {
        security = { ...security, amount: securityDeposit * 100 };
      } else {
        security = {
          ...security,
          amount: clientData?.security?.amount,
        };
      }

      if (securityDepositStatus.toString()) {
        security = {
          ...security,
          status: securityDepositStatus,
        };
      } else {
        security = {
          ...security,
          status: clientData?.security?.status,
        };
      }

      onChange({
        isKycVerified: custom_getvalue(
          isKycVerified,
          clientData?.isKycVerified
        ),
        videoKycUrl: custom_getvalue(video, clientData?.videoKycUrl),
        rollbackReserves: custom_getvalue(
          JSON.stringify(
            rollbackReserves,
            clientData?.rollbackReserves?.percentage
          )
        ),
        security: custom_getvalue(
          JSON.stringify(security),
          clientData?.security?.amount / 100
        ),
      });
    }
  }, [
    isKycVerified,
    video,
    rolling,
    rollingStatus,
    securityDeposit,
    securityDepositStatus,
  ]);

  return (
    <div style={{ margin: "0px 3%" }}>
      <div>Has the Client Opted for the VKYC ?</div>
      <div style={{ display: "flex", marginTop: 15, gap: 50 }}>
        <RadioButton
          disabled={isEditClicked ? "" : "disabled"}
          id="yes"
          name="isKycVerified"
          title="Yes"
          value={true}
          onChange={(val) => {
            setIsKycVerified(true);
            setCurrentValue("rolling");
            setRollingStatus(true);
            setSecurityDepositStatus(false);
          }}
          defaultChecked={isKycVerified === true}
        />
        <RadioButton
          disabled={isEditClicked ? "" : "disabled"}
          id="no"
          name="isKycVerified"
          title="No"
          value={false}
          onChange={(val) => {
            setIsKycVerified(false);
            setRollingStatus(true);
            setSecurityDepositStatus(true);
          }}
          defaultChecked={isKycVerified === false}
        />
      </div>
      {isKycVerified && (
        <DocumentComponent
          accept={".mp4"}
          isEditClicked={isEditClicked}
          label={"Upload Video"}
          onChange={(data) => {
            setVideo(data);
          }}
          value={video}
          imageTypeArray={["mp4"]}
          filesize={60}
        />
      )}

      {isKycVerified ? (
        <div
          style={{
            display: "flex",
            gap: 50,
            margin: "30px 0px 20px 0px",
          }}
        >
          <RadioButton
            disabled={isEditClicked ? "" : "disabled"}
            id="flat"
            name="service"
            title="Rolling Reserve"
            value="rolling"
            onChange={(val) => {
              setCurrentValue(val.target.value);
              setRollingStatus(true);
              setSecurityDepositStatus(false);
            }}
            defaultChecked={currentValue === "rolling"}
          />
          <RadioButton
            disabled={isEditClicked ? "" : "disabled"}
            id="slab"
            name="service"
            title="Security Deposit"
            value="security"
            onChange={(val) => {
              setCurrentValue(val.target.value);
              setSecurityDepositStatus(true);
              setRollingStatus(false);
            }}
            defaultChecked={currentValue === "security"}
          />
        </div>
      ) : null}

      <div>
        {(currentValue === "rolling" || !isKycVerified) && (
          <>
            {!isKycVerified && (
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Enter the rolling reserve
              </label>
            )}
            <CustomInput
              disabled={isEditClicked ? "" : "disabled"}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="eg:5%"
              validator="paise"
              maxLength={2}
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
              value={rolling}
              // value={
              //   reduxData?.rollbackReserves ? reduxData?.rollbackReserves : ""
              // }
              onChange={(data) => {
                setRolling(data);
              }}
            />
          </>
        )}

        {(currentValue === "security" || !isKycVerified) && (
          <>
            {!isKycVerified && (
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Enter the Security deposit
              </label>
            )}
            <CustomInput
              disabled={isEditClicked ? "" : "disabled"}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Enter the amount"
              type="input"
              validator="amount"
              inputStyles={{
                ...containerStyle,
              }}
              value={securityDeposit}
              // value={
              //   reduxData?.securityDeposit ? reduxData?.securityDeposit : ""
              // }
              onChange={(data) => {
                setSecurityDeposit(data);
              }}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default Vkyc;
const styles = {
  docName: {
    marginTop: 20,
    fontSize: 14,
    fontSize: 14,
    lineHeight: 2,
  },
};
